import axios from 'axios'
import {
  BaseUrl
} from './baseUrl'
// import Vue from 'vue'
import md5 from 'md5'
import {
  Message,
  MessageBox
} from 'element-ui'
import _this from '../main.js'

import qs from 'qs'
import { Logout } from '@/utils/uni'

var showLoginMessageBox = false
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// 创建axios实例

const service = axios.create({
  baseURL: BaseUrl(), // api 的 base_url
  timeout: 15000 // 请求超时时间
})
var md5Util = md5
let tokenSecret = 'KCKOSNFUONTLFSTGQWZXBRHINHYYVEMZ'
let timestamp
let token
// let requestNum = 0
// request拦截器
service.interceptors.request.use(
  (config) => {
      // requestNum = requestNum++
    timestamp = new Date().getTime()
    token = md5Util(tokenSecret + timestamp)
    console.log('timestamp:' + timestamp)
    console.log('token:' + token)
    config.headers.timestamp = timestamp
    config.headers.token = token
    config.headers.clientSource = 'pc'
    config.headers.sourceFrom = 0
    config.headers.channelNo = localStorage.getItem('c_no') || sessionStorage.getItem('c_no') || ''
    /* eslint-disable */
    let flag = config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('application/json') !== -1
    if (!flag) {
      let mult =
        config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('multipart/form-data') !== -1
      var dataCope = config.data
      if (mult) {
        config.data = dataCope
      } else {
        config.data = qs.stringify(config.data)
      }
    }
    return config
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  (response) => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    // requestNum = requestNum--
    const res = response.data
    if (res.code === 0) {
      // 文件类型特殊处理   9998 超市
      return res
    } else if (Number(res.code) !== 0) {
      // 302登录已失效
      if (res.code === 9998) {
        if (!showLoginMessageBox) {
          showLoginMessageBox = true
          if (_this.$route.path.indexOf('h5') !== -1) {
            _this.$dialog
              .alert({
                title: '确定登出',
                message: '你已被登出，请重新登录'
              })
              .then(() => {
                  Logout()
                // _this.$router.push('/h5/login')
              })
          } else if (_this.$route.path.indexOf('pc') !== -1) {
            MessageBox.confirm('你已被登出，请重新登录', '确定登出', {
              showCancelButton: false,
              showClose: false,
              confirmButtonText: '重新登录',
              type: 'warning',
              callback: (action) => {
                showLoginMessageBox = false
                _this.$router.push('/pc/login')
              }
            })
          }
        }
      } else {
        if (res.msg) {
          Message({
            message: res.msg,
            type: 'error'
          })
        }
      }
      return Promise.reject(res.msg)
    } else {
      return res
    }
  },
  (error) => {
    if (String(error).indexOf('401') > -1) {
      Message({
        message: '您的账号已在其他地方登录,即将返回登录页',
        type: 'error'
      })
      setTimeout(() => {
        location.href = ''
        sessionStorage.setItem('activeIndex', 1)
        localStorage.clear()
      }, 1000)
    } else {
      Message({
        message: '网络请求失败，请稍候再试',
        type: 'error'
      })
    }
    return Promise.reject(error)
  }
)

export default service
